import React from 'react';
import AccountUserDetailLikeProductLogModalView from './AccountUserDetailLikeProductLogModalView';
import { useAccountUserDetailLikeProductLogList } from '../hooks';

const AccountUserDetailLikeProductLogModalContainer = (props) => {
  const { userId, actionLogType, closeModal, setActionLogType } = props;
  const { likeProductLogList, filterOption, sortOption, pagination, getList } = useAccountUserDetailLikeProductLogList({
    userId,
    actionLogType,
    setActionLogType,
  });

  return (
    <AccountUserDetailLikeProductLogModalView
      closeModal={closeModal}
      likeProductLogList={likeProductLogList}
      filterOption={filterOption}
      sortOption={sortOption}
      pagination={pagination}
      getList={getList}
    />
  );
};

export default AccountUserDetailLikeProductLogModalContainer;
